// Import Data Constants....
export const mainHeading = "Data Import";
export const mainDescription =
  "Import your ESG data by downloading and filling out our Excel sheet templates. Once completed, upload these templates to our platform. This process will enable you to accurately measure and analyze your ESG metrics, providing a comprehensive overview of your organization's sustainability and ethical performance.";
export const importSectionDescription =
  "Upload your excel templates and begin importing data insidedirectly into your ESG metrics.";
